import React from 'react';
import { Container } from 'react-bootstrap';
import "../../../../assets/css/user/general/banner/Banner.css";



const Banner = ({ 
  title, 
  subtitle, 
  backgroundImage,
  darkOverlay = 0.7  
}) => {
  return (
    <section className="floating-hero-section">
      {/* Background Image */}
      <div 
        className="floating-hero-background"
        style={{ 
          backgroundImage: `url(${backgroundImage})` 
        }}
      ></div>
      
      {/* Dark Overlay */}
      <div 
        className="floating-hero-overlay"
        style={{ 
          backgroundColor: `rgba(0, 0, 0, ${darkOverlay})` 
        }}
      ></div>

      {/* Content */}
      <Container className="floating-hero-content">
        <h1 className="floating-hero-title">
          {title}
        </h1>
        {subtitle && (
          <p className="floating-hero-subtitle">
            {subtitle}
          </p>
        )}
      </Container>
    </section>
  );
};

export default Banner;